module.exports = __webpack_public_path__ + "img/sj.111a00a7.png";